<template>
  <b-tab id="tab4" title="เอกสารตามสถานะ">
    <b-row v-if="this.attachFileDate !== null">
      <b-col
        cols="5"
        class="mt-2 text-center"
      >
        ชื่อไฟล์
      </b-col>

      <b-col
        cols="4"
        class="mt-2 text-center"
      >
        ประเภทไฟล์
      </b-col>

      <b-col
        cols="3"
        class="mt-2 text-center"
      >
        จำนวนดาวน์โหลด
      </b-col>

      <hr />

      <div
        v-for="(date, index) in this.attachFileDate"
        :key="index"
        class="col-12 m-1"
      >
        <h4 v-if="filterAttachFile(date).length > 0">
          {{ date }}
        </h4>

        <b-row
          v-for="file in filterAttachFile(date)"
          :key="file.attachId"
          class="col-12 m-1"
        >
          <b-col cols="5">
            <a :href="file.filePath" :download="file.fileName" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-arrow-down-circle"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="8 12 12 16 16 12" />
                <line x1="12" y1="8" x2="12" y2="16" />
              </svg>
              {{ file.fileName }}
            </a>
          </b-col>
          <b-col cols="5" class="d-flex justify-content-center">
            {{ file.masterDescription }}
          </b-col>
          <b-col cols="1" class="d-flex justify-content-center">
            {{ file.downloadCount }}
          </b-col>
          <b-col cols="1" class="d-flex justify-content-center">
            <a
              v-if="file.isAdd === true"
              href="javascript:void(0)"
              class="text-danger"
              @click="emitDeleteFile(file.attachId)"
            >
              <feather-icon icon="Trash2Icon" size="24" />
            </a>
          </b-col>
        </b-row>
      </div>


    </b-row>

    <b-row class="mt-2" v-if="this.IsEdit_TabAttachFiles === true">
      <b-col cols="12 mt-2">
        <h4>แนบเอกสารเพิ่มเติม</h4>
      </b-col>
      <b-col md="6">
        <b-form-select v-model="selected" :options="attachTypes" class="" />
      </b-col>
      <b-col md="6">
        <b-form-file
          @change="onUploadFileChanged"
          ref="file-input"
          multiple
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-col>
      <b-col md="12" class="mt-2 d-flex justify-content-center">

      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BFormGroup,
  BFormInput,
  BTab,
  BTabs,
  BCard,
  BFormSelect,
  BButton,
  BFormFile,
} from "bootstrap-vue";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as storeMaster from "@/store/api/master/index.js";

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    BFormSelect,
    BButton,
    BFormFile,
    storeFileUpload,
    storeMaster,
  },
  props: {
    attachFiles: [],
    attachFileDate: [],
    IsEdit_TabAttachFiles: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props) {
    return {
      tabMode: props.mode,
    };
  },
  data() {
    return {
      attachTypes: [
        { value: null, text: "ประเภทเอกสาร", disabled: true },
        { text: "ประเภท1", value: 1 },
        { text: "ประเภท2", value: 2 },
        { text: "ประเภท3", value: 2 },
      ],
      selected: 13,
      files: [],
    };
  },
  created() {
    //console.log('created')
    this.getFileType();
  },
  methods: {
    getFileType() {
      const _this = this;
      storeMaster
        .getMasterByType()
        .then(function(response) {
          // handle success
          //console.log('then', response);

          var convertData = response.data.data.map(function(item, index) {
            return {
              value: item.masterId,
              text: item.description,
            };
          });

          _this.attachTypes = convertData;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    onUploadBtnClicked() {
      console.log("this.files", this.attachFiles);
    },
    onUploadFileChanged(e) {
      const selectedFiles = e.target.files;
      if (selectedFiles === null || selectedFiles === undefined || selectedFiles.length <= 0) {
        return;
      }
      const _this = this;

      var isMissing = this.onValidateExtensionFiles(selectedFiles, null);
      if (isMissing === true) {
        return;
      }

      selectedFiles.forEach(function(value, index) {
        console.log("value", value);
        _this.createBase64Image(value);
      });
    },
    createBase64Image(fileObject) {
      const _this = this;

      const reader = new FileReader();

      const fileName = fileObject.name;
      const fileSize = fileObject.size;

      reader.onload = (e) => {
        const fileBase64 = e.target.result;
        console.log(
          "fileName=",
          fileName,
          "fileSize=",
          fileSize,
          "fileType=",
          _this.selected
        );
        this.$refs["file-input"].reset();

        const data = [
          {
            fileName: fileName,
            fileSize: fileSize,
            fileBase64: fileBase64,
            fileType: _this.selected,
            masterId: _this.selected,
          },
        ];
        storeFileUpload
          .uploadFile(data)
          .then(function(response) {
            // handle success
            // console.log(response);
            response.data.data.forEach(function(value, index) {
              //console.log('emit upload', value)
              //this.$emit('handleSend', id)
              _this.emitUploadFile(value);
            });
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          })
          .then(function() {
            // always executed
          });
        //console.log('base64', base64)
      };

      reader.readAsDataURL(fileObject);
    },
    emitUploadFile(file) {
      console.log("handleUpload");
      this.$emit("handle-upload", file);
    },
    emitDeleteFile(id) {
      console.log("emitDeleteFile", id);
      this.$emit("handle-delete", id);
    },
    filterAttachFile(date) {
      try {
          console.log("child attach", this.attachFiles, this.attachFileDate);

      if (this.attachFiles === undefined || this.attachFileDate === undefined) return [];

      const filterAttach = this.attachFiles.filter((value) => {
        return value.createDateStr === date;
      });

      return filterAttach;
      }
      catch (ex) {
        return []
      }
      
    },
    onValidateExtensionFiles(selectedFiles, section) {
      console.log(`onvalidateextensionfiles.section`, section);
      let isMissing = false;

      // เช็คว่าไฟล์ที่อัพโหลดมีสกุลไฟล์หรือไม่
      // ถ้าไม่มีให้แสดง popup แจ้งเตือน
      const arrNoExtension = Object.values(selectedFiles).filter((file) => {
        return (
          file.type === null || file.type === undefined || file.type === ""
        );
      });

      if (arrNoExtension.length > 0) {
        isMissing = true;
        this.$swal({
          html:
            "<div>ไม่สามารถอัพโหลดไฟล์ที่ไม่มีสกุลไฟล์ได้<br />กรุณาตรวจสอบไฟล์ของท่านก่อนทำการอัพโหลด</div>",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        }).then((result) => {
          try {
            this.$refs["file-input"].reset();
          } catch (ex) {
            console.log(ex);
          }
        });
      }

      return isMissing;
    },
  },
  computed: {
    
  },
};
</script>

<style></style>
